import { render, staticRenderFns } from "./OrganizationPage.vue?vue&type=template&id=1cd01ac8&scoped=true&"
import script from "./OrganizationPage.vue?vue&type=script&lang=js&"
export * from "./OrganizationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd01ac8",
  null
  
)

export default component.exports